import React, { Component } from "react";
import { Loader } from "../../const/const";
import { withTranslation } from "react-i18next";
import { Container, Row, Col } from "reactstrap";
import { Helmet } from "react-helmet";
import "./PrivacyPolicy.scss";

class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      content: ""
    };
  }

  componentDidMount() {
    const thisVar = this;
    thisVar.setState({
      isLoaded: true,
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Tellus pellentesque eu tincidunt tortor aliquam nulla. Adipiscing elit pellentesque habitant morbi. Fermentum leo vel orci porta non. Tortor id aliquet lectus proin nibh nisl condimentum. Ullamcorper sit amet risus nullam eget felis eget nunc. Cras tincidunt lobortis feugiat vivamus at. Diam quis enim lobortis scelerisque fermentum dui. Elit eget gravida cum sociis natoque penatibus et magnis dis. Vulputate ut pharetra sit amet aliquam id diam. Sit amet facilisis magna etiam. Tristique risus nec feugiat in fermentum posuere. Etiam dignissim diam quis enim lobortis scelerisque fermentum dui faucibusEst ultricies integer quis auctor elit sed vulputate Dui id ornare arcu odio ut sem nullaGravida quis blandit turpis cursus. Maecenas ultricies mi eget mauris pharetra et Morbi leo urna molestie at elementum eu facilisis sed odio Diam ut venenatis tellus in metus vulputate eu scelerisque felisNon enim praesent elementum facilisis leo vel fringilla est ullamcorper Scelerisque viverra mauris in aliquam sem fringilla Id aliquet risus feugiat in ante metus dictum at tempor Id semper risus in hendrerit gravida rutrum quisque Amet risus nullam eget felis eget nunc lobortis Erat velit scelerisque in dictum non consectetur Magnis dis parturient montes nascetur ridiculus mus mauris vitae ultricies Enim blandit volutpat maecenas volutpat blandit Cras ornare arcu dui vivamus arcu. Ut ornare lectus sit amet est Ullamcorper malesuada proin libero nunc consequat. Morbi tincidunt ornare massa eget egestas purus viverra Morbi quis commodo odio aenean sed adipiscing diam donec. Tristique magna sit amet purus gravida quis blandit Parturient montes nascetur ridiculus mus Dis parturient montes nascetur ridiculus Ultricies mi quis hendrerit dolor magna Id eu nisl nunc mi ipsum faucibus vitae aliqet nec At tempor commodo ullamcorper a lacus vestibulum sed arcu non Neque vitae tempus quam pellentesque nec Sapien faucibus et molestie ac Senectus et netus et malesuada fames ac Duis ultricies lacus sed turpis Ultrices dui sapien eget mi proin sed libero enim sed Purus viverra accumsan in nisl In ornare quam viverra orci Blandit turpis cursus in hac habitasse At urna condimentum mattis pellentesque id nibh Lobortis elementum nibh tellus molestie nunc non Aliquet porttitor lacus luctus accumsanOrnare massa eget egestas purus viverra accumsan in nisl Mi sit amet mauris commodo quis imperdiet"
    });
    setTimeout(() => {
      document.getElementById("main-head").scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
      });
    }, 500);
  }

  render() {
    const { t } = this.props;
    const { isLoaded, content } = this.state;
    if (!isLoaded) {
      return <Loader />;
    } else {
      return (
        <div>
          <Helmet>
            <title>GLC Paints | Privacy Policy</title>
            <meta name="description" content="PRIVACY POLICY" />
          </Helmet>
          <section className="main-bg">
            <div className="big-title">
              <div className="title-center">
                <h1>{t("Privacy Policy")}</h1>
              </div>
            </div>
          </section>
          <section className="main-bg space">
            <div className="blog-tabs">
              <div className="content">
                <div className="blog-one pb-60">
                  <Container fluid>
                    <Row>
                      <Col xs={12} md={12}>
                        <div>
                          <div className="privacy-content">
                            <p>{content}</p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
            </div>
          </section>
        </div>
      );
    }
  }
}

export default withTranslation("common")(PrivacyPolicy);
